import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BllChecboxComponent } from './checkbox.component';

@NgModule({
  imports: [CommonModule],
  declarations: [BllChecboxComponent],
  exports: [BllChecboxComponent],
})
export class BllCheckboxModule {}
